import {
  ALL_CATEGORY_KEY,
} from "./accessoryMappers";
import {
  DEFAULT_RADIUS_KM,
  DEFAULT_SORT,
  INITIAL_FILTERS,
  SORT_OPTIONS,
  clampRadiusKm,
  normaliseFilters,
} from "./accessoryFilters";

export const URL_KEYS = Object.freeze({
  category: "c",
  term: "q",
  materials: "m",
  minPrice: "min",
  maxPrice: "max",
  radius: "r",
  stock: "stock",
  sort: "sort",
});

const readNumber = (params, key) => {
  const raw = params.get(key);

  if (raw === null || raw === "") return null;

  const parsed = Number(raw);

  return Number.isFinite(parsed) ? parsed : null;
};

export const readUrlState = (searchParams) => {
  const params = searchParams || new URLSearchParams();

  const rawMaterials = params.get(URL_KEYS.materials) || "";

  const materialIds = rawMaterials
    .split(",")
    .map((value) => Number(value.trim()))
    .filter((value) => Number.isFinite(value) && value > 0);

  const rawRadius = params.get(URL_KEYS.radius);
  const rawSort = params.get(URL_KEYS.sort);

  return {
    categoryCode: params.get(URL_KEYS.category) || null,
    term: params.get(URL_KEYS.term) || "",
    filters: normaliseFilters({
      ...INITIAL_FILTERS,
      materialIds,
      minPrice: readNumber(params, URL_KEYS.minPrice),
      maxPrice: readNumber(params, URL_KEYS.maxPrice),
      radiusKm:
        rawRadius === "any"
          ? null
          : rawRadius === null
          ? DEFAULT_RADIUS_KM
          : clampRadiusKm(Number(rawRadius)) ?? DEFAULT_RADIUS_KM,
      inStockOnly: params.get(URL_KEYS.stock) === "1",
      sort: SORT_OPTIONS.some((option) => option.value === rawSort)
        ? rawSort
        : DEFAULT_SORT,
    }),
  };
};

export const writeUrlState = ({ categoryCode, term, filters }) => {
  const values = normaliseFilters(filters);
  const params = new URLSearchParams();

  if (categoryCode && categoryCode !== ALL_CATEGORY_KEY) {
    params.set(URL_KEYS.category, categoryCode);
  }

  const trimmed = String(term || "").trim();
  if (trimmed) params.set(URL_KEYS.term, trimmed);

  if (values.materialIds.length) {
    params.set(URL_KEYS.materials, values.materialIds.join(","));
  }

  if (values.minPrice !== null) params.set(URL_KEYS.minPrice, String(values.minPrice));
  if (values.maxPrice !== null) params.set(URL_KEYS.maxPrice, String(values.maxPrice));

  if (values.radiusKm === null) params.set(URL_KEYS.radius, "any");
  else if (values.radiusKm !== DEFAULT_RADIUS_KM) {
    params.set(URL_KEYS.radius, String(values.radiusKm));
  }

  if (values.inStockOnly) params.set(URL_KEYS.stock, "1");

  if (values.sort !== DEFAULT_SORT) params.set(URL_KEYS.sort, values.sort);

  return params;
};

export const urlStateEqual = (left, right) =>
  writeUrlState(left).toString() === writeUrlState(right).toString();
